import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BuildInfoService } from '../../services/build-info.service';

@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss'],
  imports: [
    AsyncPipe,
    RouterLink
  ],
  standalone: true
})
export class MainFooterComponent {
  private readonly buildInfoService = inject(BuildInfoService);

  protected readonly footerBuildInfo$ = this.buildInfoService.getFooterBuildInfo();
}
